// extracted by mini-css-extract-plugin
export default {"previewBox":"workflowThemePreview_previewBox__vMDkV","preview":"workflowThemePreview_preview__8BT2R"};